import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import { useHistory, withRouter } from 'react-router-dom';
import * as PROJECT_CODE from '../../../constants/projectCode';
import MailIcon from '@material-ui/icons/Mail';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import PhoneIcon from '@material-ui/icons/Phone';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ScheduleIcon from '@material-ui/icons/Schedule';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CloseIcon from '@material-ui/icons/Close';
import dayjs from 'dayjs';
import { GetAllVisibleClients } from '../../../components/clients/getAllVisibleClients'; //SetClientToNotVisible
import { SetClientToNotVisible } from '../../../components/clients/setClientToNotVisible';
import './ClientDetails.css';
import { CompassCalibrationOutlined } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';

const ClientDetails = () => {
	const { firebase } = useContext(FirebaseContext);
	const history = useHistory();
	const [clientDetailList, setClientDetailList] = useState([]);
	const [alert, setAlert] = useState('');
	const [isDeleting, setIsDeleting] = useState(false);

	const [userType, setUserType] = useState('');

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;
				var capFirst;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE: ' + currentUserType);
					});
				setUserType(currentUserType);
			}
		});
	}, []);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;

				GetAllVisibleClients(firebase).then((returned) => {
					//console.log("Return Test " + returned[0].clientEmail);

					setClientDetailList(returned);
				});
			}
		});
	}, []);

	const handleDocument = useCallback(async (e) => {
		try {
			var currentUserId = firebase.auth().currentUser.uid;
			var currentUserEmail = firebase.auth().currentUser.email;
			var currentUserType;
			var currentUserPhoneNumber;
			var currentUserName;
			var clientName = e.currentTarget.dataset.name;
			var appCode = e.currentTarget.dataset.appcode;

			// console.log('type: ' + currentUserId + ', email: ' + currentUserEmail);
			console.log('appCode ' + appCode);

			var clientEmailData = e.currentTarget.dataset.clientemail;
			console.log(
				'clientEmailData ' + clientEmailData + ' client Name ' + clientName
			);

			await firebase
				.database()
				.ref('/users/' + currentUserId)
				.once('value', (snapshot) => {
					currentUserType = snapshot.val().userType;
					currentUserPhoneNumber = snapshot.val().phoneNumber;
					currentUserName = snapshot.val().fullName;

					console.log(
						'Type: ' +
							currentUserType +
							', username: ' +
							currentUserName +
							', phone: ' +
							currentUserPhoneNumber
					);

					var detailsUser = {
						thisEmail: currentUserEmail,
						thisName: currentUserName,
						thisUserType: currentUserType,
						thisPhone: currentUserPhoneNumber,
						thisUID: currentUserId,
					};

					console.log('Details user: ' + JSON.stringify(detailsUser));

					// history.push({
					// 	pathname: '/doc',
					// 	state: {
					// 		clientEmail: clientEmailData,
					// 		clientFName: clientName,
					// 		userDetail: detailsUser,
					// 		sellerFullName: currentUserName,
					// 		sellerPhone: currentUserPhoneNumber,
					// 		clientAppCode: appCode,
					// 	},
					// });

					if (userType === 'admin' || userType === 'superadmin') {
						history.push({
							pathname: '/doc',
							state: {
								clientEmail: clientEmailData,
								clientFName: clientName,
								userDetail: detailsUser,
								sellerFullName: currentUserName,
								sellerPhone: currentUserPhoneNumber,
								clientAppCode: appCode,
							},
						});
					} else if (userType === 'client') {
						history.push({
							pathname: '/doc-client',
							state: {
								clientEmail: clientEmailData,
								clientFName: clientName,
								userDetail: detailsUser,
								sellerFullName: currentUserName,
								sellerPhone: currentUserPhoneNumber,
							},
						});
					}
				});
		} catch (error) {
			console.log(error);
		}
	});

	const handleDelete = useCallback(async (e) => {
		var allKeysToDelete = [];
		var deleteKey = e.currentTarget.dataset.appcode;
		var clientName = e.currentTarget.dataset.name;
		var clientEmail = e.currentTarget.dataset.clientemail;
		console.log('delete key : ' + deleteKey);
		e.preventDefault();

		SetClientToNotVisible(firebase, clientEmail).then(() => {
			setAlert(`Client of name ${clientName} has been deleted.`);
			setTimeout(() => setAlert(''), 4000);

			GetAllVisibleClients(firebase).then((returned) => {
				//console.log("Return Test " + returned[0].clientEmail);

				setClientDetailList(returned);
			});
		});
	});

	return (
		<div className='client-details m-bottom'>
			{alert && <p className='form-alert'>{alert}</p>}
			<h2>CLIENT DETAILS</h2>
			<div className='client-details-table'>
				<table>
					<tr>
						<th>Full name</th>
						<th>Email</th>
						<th>Phone Number</th>
						<th>Client Since</th>
						<th>Documents</th>
						<th>Manage</th>
					</tr>
					{clientDetailList &&
						console.log(
							'Inside the html client list: ' + JSON.stringify(clientDetailList)
						)}
					{clientDetailList?.map((client) => {
						var dateObj = new Date(client.timeOfAppointment);

						return (
							<tr key={client.clientEmail} id={client.clientKey}>
								<td>
									<div className='clientFullName'>
										<span>{client.fullName}</span>
									</div>
								</td>
								<td>
									<div className='clientMail'>
										<span>{client.clientEmail}</span>
									</div>
								</td>
								<td>
									<div className='clientPhone'>
										<span>{client.phoneNumber}</span>
									</div>
								</td>
								<td>
									<div className='clientDate'>
										<span>
											{dayjs(dateObj).format('DD MMM, YYYY')} &nbsp; &nbsp;
											&nbsp;{' '}
										</span>
									</div>
								</td>
								<td>
									<Tooltip title='Create Document'>
										<button
											className='btnDocument'
											data-id={client.clientEmail}
											data-name={client.fullName}
											data-appcode={client.appCode}
											onClick={handleDocument}
											data-clientemail={client.clientEmail}
										>
											<InsertDriveFileIcon />
										</button>
									</Tooltip>
								</td>
								<td>
									<Tooltip title='Delete'>
										<button
											className='btnDelete'
											onClick={handleDelete}
											data-appcode={client.appCode}
											data-name={client.fullName}
											data-clientemail={client.clientEmail}
										>
											<CloseIcon />
										</button>
									</Tooltip>
								</td>
							</tr>
						);
					})}
				</table>
			</div>
		</div>
	);
};

export default withRouter(ClientDetails);
